import { extend, configure } from 'vee-validate';
import { required, required_if, min, max, email, numeric } from 'vee-validate/dist/rules';
import i18n from './i18n';
import { isValidPhoneNumber, validatePhoneNumberLength } from 'libphonenumber-js/mobile';

configure({
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`fields.${field}`);
    return i18n.t(`validation.${values._rule_}`, values);
  }
});

extend('required', required);
extend('required_if', required_if);
extend('min', min);
extend('max', max);
extend('email', email);
extend('numeric', numeric);
extend('password', {
  params: ['target'],
  validate(value, { target }) {
    return value === target;
  }
});
extend('latitude', { validate: num => isFinite(num) && Math.abs(num) <= 90 })
extend('longitude', { validate: num => isFinite(num) && Math.abs(num) <= 180 })
extend('gt0', { validate: num => num > 0 })

extend('required_without', {
  params: ['target'],
  computesRequired: true,
  validate(value, {target}) {
    return {
      valid: value || target,
      required: !target,
    };
  },
});

extend('phone', { 
  params: ['country'],
  validate(phone,{country}) {
    if(!isValidPhoneNumber(phone,country)) {
      const reason = validatePhoneNumberLength(phone,country)
      return i18n.t('validation.phone.' + (reason || 'INVALID'))
    }

    return true
  }
})